import React from 'react'
import * as FlexWebChat from '@twilio/flex-webchat-ui'
import './validators/extend_validations'
import {
  PreEngagementForm,
  PreEngagementFormLogged,
  CustomMessageBubble,
  MessageCanvasTray
} from './components'
import HideChat from './components/HideChat'
import CustomHeader from './components/CustomHeader'

import getConfig from './webchat-appConfig'
import Locales from './locales'
import * as UserHelper from './utils/user'

const STAGES = {
  CF_IN_ENGAGEMENT: 'CF_IN_ENGAGEMENT',
  CF_INIT_ENGAGEMENT: 'CF_INIT_ENGAGEMENT',
  CF_PRE_ENGAGEMENT: 'CF_PRE_ENGAGEMENT',
  NO_FLEX_CREATED: 'NO_FLEX_CREATED',
  NO_SESSION_FOUND: 'NO_SESSION_FOUND',
  ERROR_WITH_SESSION: 'ERROR_WITH_SESSION',
  IN_PROGRESS: 'IN_PROGRESS',
  INITIALIZING: 'INITIALIZING'
}

const BREAKING_DATE = new Date('2023-07-10')

class App extends React.Component {
  state = {}
  
  getSessionStage = () => {
    const flex = window.localStorage.getItem('twilio-flex-cf')

    if (flex) {
      try {
        const {
          flex: { session }
        } = JSON.parse(flex)
        if (session) return session.engagementStage
        else return STAGES.NO_SESSION_FOUND
      } catch (error) {
        console.error(error)
        return STAGES.ERROR_WITH_SESSION
      }
    } else {
      return STAGES.NO_FLEX_CREATED
    }
  }

  isEntryPointExpanded = () => {
    const flex = window.localStorage.getItem('twilio-flex-cf')
    if (flex) { 
      try {
        const {
          flex: { session }
        } = JSON.parse(flex)
        if (session) return session.isEntryPointExpanded
        else return false
      } catch (error) {
        console.error(error)
        return false
      }
    } else {
      return false
    }
  }

  getChatStage = () => {
    return window.localStorage.getItem('flapperChatStage') || undefined
  }

  getLastSession = () => {
    return window.localStorage.getItem('flapperChatLastSession') || undefined
  }

  clearOldCachedStages = () => {
    console.log('CLEARING WEBCHAT CACHE...')
    window.localStorage.removeItem('twilio_twilsock_token_storage')

    for (var i = 0; i < localStorage.length; i++) {
      const key = window.localStorage.key(i)

      if (key.includes('twilio')) window.localStorage.removeItem(key)
    }
  }

  setLastSession = () => {
    return window.localStorage.setItem('flapperChatLastSession', new Date())
  }

  getChatVisibility = () => {
    return window.sessionStorage.getItem('flapperChatVisibility') == 'true'
  }

  toggleChatVisibility = () => {
    FlexWebChat.Actions.invokeAction('ToggleChatVisibility')
  }

  sendMessage = (msg = '', failedMsg = '') => {
    try {
      const manager = this.state.manager
      const { channelSid } = manager.store.getState().flex.session
      const chatVisibility = this.getChatVisibility()

      manager.chatClient.getChannelBySid(channelSid).then((channel) => {
        try {
          channel.sendMessage(msg)
          if (!chatVisibility)
            FlexWebChat.Actions.invokeAction('ToggleChatVisibility')
        } catch (error) {
          console.warn(error)
          channel.sendMessage(failedMsg)
        }
      })
    } catch (error) {
      console.error(error)
    }
  }

  createWidget = (data, create = false) => {
    const user = UserHelper.getUserInfo()
    const isLogged = !!user?.phone
    const isFirstRender = JSON.parse(sessionStorage.getItem('isFirstRender') || "true")

    const config = getConfig(isLogged, user)
    const translations = Locales.getTranslations()
    const chatStage = this.getChatStage()

    console.log('CHECKING WEBCHAT STAGE...', chatStage)

    if (
      !create &&
      !(chatStage === STAGES.IN_PROGRESS || chatStage === STAGES.INITIALIZING)
    ) {
      console.log('AVOIDING WEBCHAT INITIALIZATION...')
      return null
    }

    FlexWebChat.Manager.create(config)
      .then((manager) => {
        console.log({manager})
        this.setState({ manager })
        localStorage.setItem('flapperChatStage', 'INITIALIZING')
        this.setLastSession()

        console.log('CREATING WEBCHAT...')

        // FlexWebChat.Actions.invokeAction('ToggleChatVisibility')

        try {
          if (isLogged) {
            console.log("pré engajamento, logado")
            FlexWebChat.PreEngagementCanvas.Content.replace(
              <PreEngagementFormLogged
                key='pre-engagement-form-logged'
                manager={manager}
                user={user}
                data={data}
              />
            )
            this.toggleChatVisibility()
          } else {
            console.log("pré engajamento, não logado")
            FlexWebChat.PreEngagementCanvas.Content.replace(
              <PreEngagementForm key='pre-engagement-form' manager={manager} />
            )
            this.toggleChatVisibility()
          }
        } catch (error) {
          console.error(error)
        }

        FlexWebChat.Actions.addListener('afterStartEngagement', (payload) => {
          const { strInfo = translations['message.quotation_fail'] } = data

          if (!this.isEntryPointExpanded()) {
            FlexWebChat.Actions.invokeAction('ToggleChatVisibility')
          }

          setTimeout(() => {
            this.sendMessage(strInfo)
          }, 3000)
        })

        FlexWebChat.Actions.addListener(
          'afterToggleChatVisibility',
          (payload) => {
            console.log({isEntryPointExpanded: this.isEntryPointExpanded()})
            if (this.isEntryPointExpanded()) {
              sessionStorage.setItem('flapperChatVisibility', true)
            }
          }
        )

        FlexWebChat.MessageBubble.Content.replace(
          <CustomMessageBubble key='custom-message-bubble' manager={manager} />
        )

        const chatVisibility = this.getChatVisibility()
        const SESSION_STAGE = this.getSessionStage()


        console.log('CHECKING WEBCHAT VISIBILITY...', chatVisibility)
        if(window.location.pathname.includes("checkout")) return

        if (!chatVisibility) {
          if (SESSION_STAGE == 'CF_INIT_ENGAGEMENT') {
            FlexWebChat.Actions.invokeAction('ToggleChatVisibility')
          } else {
            FlexWebChat.Actions.invokeAction('MinimizeChat')
          }
        }

        if(!isFirstRender) {
          FlexWebChat.Actions.invokeAction('MinimizeChat')
        }

        sessionStorage.setItem('isFirstRender', false)
      })
      .catch((error) => {
        console.log(error)
        this.setState({ error })
      })
    // FlexWebChat.EntryPoint.defaultProps.tagline = translations['badge.tagline']
    FlexWebChat.EntryPoint.defaultProps.hideTaglineWhenExpanded = true

    FlexWebChat.MainContainer.defaultProps.width = '476px'
    FlexWebChat.MainContainer.defaultProps.bottom = '20px'

    FlexWebChat.MainHeader.defaultProps.imageUrl =
      process.env.REACT_APP_URL + 'logo.svg'
    FlexWebChat.MainHeader.defaultProps.titleText = 'Flapper Chat'
    FlexWebChat.MainHeader.defaultProps.showTitle = true
    FlexWebChat.MainHeader.defaultProps.showImage = true

    FlexWebChat.MessagingCanvas.defaultProps.showWelcomeMessage = false
    FlexWebChat.MessagingCanvas.defaultProps.predefinedMessage = null

    FlexWebChat.MessageCanvasTray.Content.replace(
      <MessageCanvasTray key='custom-canvas-tray' />
    )

    FlexWebChat.RootContainer.Content.add(<HideChat key='hide-chat' />)

    FlexWebChat.MainHeader.Content.replace(<CustomHeader key='custom-header'/>)

    console.log('WEBCHAT CREATED!')
  }

  execByStage = (create = false, data = {}) => {
    const chatContainer = document.getElementById('twilio-chat-component')
    const SESSION_STAGE = this.getSessionStage()
    const chatStage = this.getChatStage()
    const translations = Locales.getTranslations()

    console.log(`SESSION_STAGE: ${SESSION_STAGE}`)

    console.log('EXECUTING WEBCHAT INITIALIZATION...')

    if (chatContainer && chatContainer.hasChildNodes()) {
      console.log('WEBCHAT FOUND!')
      try {
        switch (SESSION_STAGE) {
          case STAGES.CF_IN_ENGAGEMENT:
          case STAGES.CF_PRE_ENGAGEMENT:
            const { strInfo = translations['message.quotation_fail'] } = data

            this.sendMessage(strInfo, translations['message.quotation_fail'])
            break

          default:
            break
        }
      } catch (error) {
        console.error(error)
      }
    } else if (chatContainer && !chatContainer.hasChildNodes()) {
      console.log('NO WEBCHAT FOUND...')
      if (!create) {
        switch (SESSION_STAGE) {
          case STAGES.CF_IN_ENGAGEMENT:
          case STAGES.CF_INIT_ENGAGEMENT:
            console.log('WEBCHAT STAGE INIT...')
            this.createWidget(data)
            break
          case STAGES.CF_PRE_ENGAGEMENT:
            console.log('WEBCHAT STAGE IN PROGRESS...')
            this.createWidget(data)
            break

          case STAGES.NO_FLEX_CREATED:
          case STAGES.NO_SESSION_FOUND:
          case STAGES.ERROR_WITH_SESSION:
            console.log('WEBCHAT STAGE TO BE INITIALIZED...')
            if (create || chatStage == STAGES.INITIALIZING) {
              this.createWidget(data, create)
            }
            break

          default:
            break
        }
      } else {
        this.createWidget(data, create)
      }
    }
  }

  onPageLoad = () => {
    const lastSession = this.getLastSession()

    if (!lastSession || lastSession < BREAKING_DATE) this.clearOldCachedStages()

    this.execByStage()

    window.addEventListener(
      'message',
      (event) => {
        if (process.env.REACT_APP_MODE !== 'dev') {
          if (!event.origin.includes('flyflapper.com')) {
            throw new Error('CORS error')
          }
        }

        const data = event.data

        try {
          if (data.type === 'CHECK_AVAILABILITY') {
            console.log({ data })
            this.execByStage(data.show, data)
            console.log('check availability')
          }

          if(data.type === 'TOGGLE_CHAT_VISIBILITY') {
            this.toggleChatVisibility()
          }
        } catch (error) {
          console.error(error)
        }
      },
      { once: false }
    )
  }

  constructor(props) {
    console.log('CONSTRUCTOR INITIALIZED...')
    super(props)

    this.onPageLoad()
  }


  componentDidMount() {
    const isFirstRender = sessionStorage.getItem('isFirstRender')

    if(isFirstRender !== "false" ) {
      sessionStorage.setItem('isFirstRender', true)
    }
  }

  render() {
    const { manager, error } = this.state

    console.log({ manager, error })

    if (manager) {
      return (
        <FlexWebChat.ContextProvider manager={manager}>
          <FlexWebChat.RootContainer />
        </FlexWebChat.ContextProvider>
      )
    }

    if (error) {
      console.error('Failed to initialize Flex Web Chat', error)
    }

    return null
  }
}

export default App
